<template>
    <div>
        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>

            <vue-headful :title="`Clone: ${form.form_name}  :: MeritEHS`"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/inspections/forms`">
                            <i class="fa fa-clipboard"></i> Inspection Forms
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/inspections/forms/view/${form.inspection_form_id}`">
                            {{ form.form_name }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">Clone</li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-xl-5 col-lg-6">
                    <div class="card">
                        <div class="card-body">
                            <div class="form-group row">
                                <label :class="{ 'col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.form_name }">Form Name: <i class="fa fa-asterisk text-danger small"></i></label>
                                <div class="col-sm-8">

                                    <input type="text" v-model="form.form_name" :class="{'form-control': true, 'is-invalid': errors.form_name}">

                                    <span v-if="errors.form_name" class="text-danger">
                                        <span v-for="error in errors.form_name">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <hr/>

                            <button type="button" class="btn btn-sm btn-warning" v-on:click="cloneForm()">Clone Form</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    data: function() {
        return {
            saving: false,
            loading: true,
            inspection_form_id: this.$route.params.id,
            form: {},
            errors: {},
        }
    },

    methods: {
        getForm() {
            //Get the data
            this.$http
                .get('inspections/forms/clone/' + this.inspection_form_id)
                .then(response => {
                    //Set all the data
                    this.form = response.data;

                    //Set loading
                    this.loading = false;
                })
                .catch(response => {

                });
        },

        cloneForm(){
            //Helpers
            this.saving = true;

            //Get the data
            this.$http
                .post('inspections/forms/clone/' + this.inspection_form_id, this.form)
                .then(response => {
                    //Alert
                    this.$toastr.success('Form Cloned');

                    //Send to new Edit
                    this.$router.push('/inspections/forms/edit/' + response.data.inspection_form_id);
                })
                .catch(response => {
                    //Alert
                    this.$toastr.error(err.response.data);
                })
                .then(() => {
                    //Saving
                    this.saving = false;
                })
        },
    },

    mounted() {
        //Get the inspections
        this.getForm();
    }
}
</script>
